import { useNavigation } from '@react-navigation/native'
import { Image, StyleSheet, View } from 'react-native'
import HelperCart from 'utils/helper-cart'
import { routeBookingConstants, routeBookingConstantValues } from 'utils/constants/route/RouteBookingConstants'
import { bookingOptions } from 'utils/constants/booking-constants'
import { AppRoutes } from 'navigations/app-routes'
import { colorList } from 'utils/colors'
import IconBackground, { IconBackgroundSizes } from 'components/atoms/IconBackground'
import HelperString from 'utils/helper-string'
import { ThemedShared } from 'styles/themed'
import ThemedPressable from 'components/atoms/ThemedPressable'
import ThemedItem from 'components/atoms/ThemedItem'
import React from 'react'
import { timeslotGroupForTitle } from 'scenes/home/book/coworker/_functions/TimeslotGroupFunctions'
import _ from 'lodash'
import { getNextLocationRoute, ungroupForcedTimeslotsFromForcedGuids } from 'scenes/home/book/_functions/RouteHelpers'
import HelperTestID from 'utils/HelperTestID'
import { TESTID } from '_shared/config/testID'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'

export const BookOption = ( { timeslotGroup, forOption, forcedGuids, onPress, iconImage } ) => {
	const navigation = useNavigation();
	
	const onPressItem = () => {
		if( onPress ) {
			onPress();
			return;
		}
		
		HelperCart.resetAll();
		HelperCart.cartBookSetForOption( forOption );
		
		let navigationData = {
			routeLocation: null,
			routeParams: {
				[ routeBookingConstants.TIMESLOT_GROUP ]: timeslotGroup.guid,
				[ routeBookingConstants.FOR_OPTION ]: forOption,
			}
		}
		
		if( !_.isEmpty( forcedGuids ) ) {
			navigationData.routeParams = {
				...navigationData.routeParams,
				...ungroupForcedTimeslotsFromForcedGuids( {...forcedGuids} )
			};
		}
		
		switch( forOption ) {
			case bookingOptions.MYSELF:
				// When there are multiple buildings we always have to go to the location selection
				if( _.size( timeslotGroup.buildingTree ) > 1 ) {
					navigationData.routeLocation = AppRoutes.ADD_BOOKING_LOCATION;
				} else {
					// Otherwise we can find the next location
					navigationData.routeParams[ routeBookingConstants.DEPTH_LEVEL ] = routeBookingConstantValues[ routeBookingConstants.DEPTH_LEVEL ].BUILDING;
					
					navigationData = getNextLocationRoute( navigationData.routeParams, Object.values( timeslotGroup.buildingTree )[ 0 ] );
				}
				break;
			default:
				navigationData.routeLocation = AppRoutes.ADD_BOOKING_SELECT_COWORKER;
		}
		
		navigation.navigate( AppRoutes.ADD_BOOKING, {
			screen: navigationData.routeLocation,
			params: navigationData.routeParams
		})
		
		//navigation.navigate( navigationData.routeLocation, navigationData.routeParams );
	};
	
	const title = timeslotGroupForTitle( forOption, timeslotGroup )
	let icon = null;
	
	switch( forOption ) {
		case bookingOptions.MYSELF:
			icon = <Icon icon={ IconSystemConstants.PERSON } size={ 24 } color={ colorList.PRIMARY.dark } />;
			break;
			
		case bookingOptions.MYSELF_AND_COWORKERS:
			icon = <Icon icon={ IconSystemConstants.PERSONS }  size={ 24 } color={ colorList.PRIMARY.dark } />;
			break;
		
		case bookingOptions.COWORKERS:
			icon = <Icon icon={ IconSystemConstants.PERSONS }  size={ 24 } color={ colorList.PRIMARY.dark } />;
			break;
	}
	
	if( iconImage ) {
		icon = (
			<Image
				source={ iconImage }
				resizeMethod="contain"
				style={styles.imageWidth90Height90}
			/>
		);
	}
	
	// No title... No view... (Bob Marley)
	if( title === null ) {
		return null;
	}
	
	icon = (
		<IconBackground
			key={ HelperString.hash('start-place-icon', timeslotGroup.guid +'-'+ forOption ) }
			colourfull
			iconSize={ IconBackgroundSizes.M }
			linearGradientColours={ [ colorList.WHITE.primary, colorList.WHITE.dark ] }
			containerStyle={ ThemedShared.borderRadius }
			opacity={ 0.6 }>
			
			<View style={ styles.bookForOptionIconIconContainer }>
				{ icon }
			</View>
		</IconBackground>
	);
	
	return (
		<ThemedPressable
			key={ HelperString.hash('start-place-item', `${ timeslotGroup.guid }_${ forOption }`) }
			onPress={ onPressItem }
			accessibilityRole="button"
			accessibilityLabel={ title }
			testID={ HelperTestID.generate( TESTID.HOME.BOOK.START.TIMESLOT_GROUP.BOOK_OPTION, [ timeslotGroup.guid, forOption ] )}>
			
			<ThemedItem
				accessoryLeft={ icon }
				accessoryLeftSize={ 50 }
				actionItem={
					<Icon
						icon={ IconSystemConstants.ARROW_RIGHT }
						style={ styles.chevron }
					/>
				}
				title={ title }
			/>
		</ThemedPressable>
	)
}

const styles = StyleSheet.create( {
	imageWidth90Height90: {
		width: '90%',
		height: '90%',
	},
	bookForOptionIconIconContainer: {
		width: 50,
		height: 50,
		justifyContent: 'center',
		alignItems: 'center',
	},
	chevron: {
		fontSize: 14,
		color: colorList.TEXT_HINT.primary,
	},
});
